import { Spin } from 'antd';
import React, { Suspense } from 'react';

interface ILazyRouteProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const LazyRoute: React.FC<ILazyRouteProps> = ({
  children,
  fallback,
}) => {
  const defaultFallback = (
    <div data-testid="lazy-route-loading">
      <Spin size="large" fullscreen description="Loading..." />
    </div>
  );

  return <Suspense fallback={fallback || defaultFallback}>{children}</Suspense>;
};

export default LazyRoute;
